export default __webpack_public_path__ + "static/media/signin.08d38abd.jpg";